import TimeoutWarningModalComponent from './timeout-warning-modal-component';

/***
 *  A modal that displays a countdown timer for the user informing them when they will be logged out for idling.
 *  Displays an updated message once the user has been logged out.
 */
const timeoutWarningModal = angular
    .module('TimeoutWarningModal', [])
    .component('timeoutWarningModal', TimeoutWarningModalComponent)
    .name;

export default timeoutWarningModal;


// WEBPACK FOOTER //
// ./app/common/timeout-warning/timeout-warning-modal/timeout-warning-modal.js